import { render, staticRenderFns } from "./PositionEmailTextArea.vue?vue&type=template&id=5b9139c1"
import script from "./PositionEmailTextArea.vue?vue&type=script&lang=js"
export * from "./PositionEmailTextArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports